<template>
    <SideFormSection>
        <template #title>Natural Language</template>
        <template #rawContent>
            <Card
                title="Natural Language"
                iconName="magic-sparkles"
            >
                <template #content>
                    <ApiForm
                        :url="
                            urlFactory.makeAvailabilityUpdateAiUrl(
                                availability.id,
                            )
                        "
                        ref="apiFormRef"
                    >
                        <AvailabilityAiForm
                            :key="formKey"
                            :errors="
                                apiFormRef?.response?.getErrors() ??
                                new ApiFormErrors({})
                            "
                        />
                    </ApiForm>
                </template>
                <template #actions>
                    <Button
                        @click="submit"
                        :disabled="availability.cannotBeManagedBy(companyUser)"
                        :loading="apiFormRef?.loading.valueOf()"
                        iconName="save"
                    >
                        Apply
                    </Button>
                </template>
            </Card>
        </template>
    </SideFormSection>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { ref, type PropType } from 'vue'
    import Availability from '@/App/Availability/Entity/Availability'
    import AvailabilityAiForm from '@/App/Availability/Component/AvailabilityAiForm.vue'
    import CompanyUser from '@/App/CompanyUser/Entity/CompanyUser'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import ApiFormResponseType from '@/Shared/Component/Forms/ApiFormResponseType'
    import Button from '@/Shared/Component/Button.vue'
    import Card from '@/Shared/Component/Card.vue'
    import SideFormSection from '@/Shared/Component/SideFormSection.vue'
    import { ResponseJsonKeyEnum } from '@/Shared/AutoGenerated/Main'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'

    const emit = defineEmits<{
        onSuccess: [availability: Availability]
    }>()

    const props = defineProps({
        availability: {
            type: Object as PropType<Availability>,
            required: true,
        },
        companyUser: {
            type: Object as PropType<CompanyUser>,
            required: true,
        },
    })

    const apiFormRef = ref<ApiFormRefType>(null)
    const formKey = ref<number>(0)

    function submit(): void {
        apiFormRef.value?.submit()?.then((response: ApiFormResponseType) => {
            formKey.value += 1

            emit(
                'onSuccess',
                response.getHydratedAvailability(
                    ResponseJsonKeyEnum.App_Availability_AvailabilityData,
                ),
            )
        })
    }
    const urlFactory = new UrlFactory()
</script>
